import React from 'react';
import { stats } from '../data/content';
export function ProofBar() {
  return <section className="w-full border-y border-white/5 bg-night-900 py-12 md:py-16" data-id="element-150" data-mp="m9p3oi777tfr">
      <div className="mx-auto w-full max-w-content px-5 md:px-8" data-id="element-151" data-mp="mbt7z190eugk">
        <dl className="grid gap-10 text-center md:grid-cols-3" data-id="element-152" data-mp="7kj42t4g817c">
          {stats.map(stat => <div key={stat.label} data-id="element-153" data-mp="cikp3jlfqalg">
              <dt className="sr-only" data-id="element-154" data-mp="3ups0tu0opzpu">{stat.label}</dt>
              <dd data-id="element-155" data-mp="3uo74byut86pc">
                <span className="block font-display text-4xl font-bold tracking-tight text-gold-300 md:text-5xl" data-id="element-156" data-mp="3uruzt3jtf36p">
                  {stat.value}
                </span>
                <span className="mt-2 block text-sm font-medium text-muted" data-id="element-157" data-mp="3ksw0ibkxwjwd">{stat.label}</span>
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}